import { useMemo, type ComponentType } from "react";
import { useTranslation } from "react-i18next";
import { CustomSelect } from "sipli-fleet-core/components";
import CustomSharedInput from "sipli-fleet-core/components/CustomSharedInput/CustomSharedInput";
import { CrossIcon, SearchIcon } from "src/assets/svgs";

export type TachographCardSortDirection = "ASC" | "DESC";

interface TachographCardsToolbarProps {
  search: string;
  sortDirection: TachographCardSortDirection;
  disabled?: boolean;
  onSearchChange: (value: string) => void;
  onSortDirectionChange: (value: TachographCardSortDirection) => void;
}

const Icon = (asset: unknown) => asset as ComponentType<{ className?: string }>;

const CrossIconComponent = Icon(CrossIcon);
const SearchIconComponent = Icon(SearchIcon);

const isSortDirection = (value: unknown): value is TachographCardSortDirection =>
  value === "ASC" || value === "DESC";

const TachographCardsToolbar = ({
  search,
  sortDirection,
  disabled = false,
  onSearchChange,
  onSortDirectionChange,
}: TachographCardsToolbarProps) => {
  const { t } = useTranslation();

  const sortOptions = useMemo(
    () => [
      { label: t("ascending"), value: "ASC" },
      { label: t("descending"), value: "DESC" },
    ],
    [t]
  );

  return (
    <div className="flex flex-col gap-4 px-[24px] pt-[18px] pb-[22px] sm:flex-row sm:items-end sm:justify-between">
      <CustomSharedInput
        allowClear={{
          clearIcon: <CrossIconComponent className="mr-0.5 h-[8.5px] w-[8.5px]" />,
        }}
        prefix={<SearchIconComponent className="h-[14px] w-[14px]" />}
        placeholder={t("search")}
        value={search}
        disabled={disabled}
        className="global-filter-search-class !h-[32px] !w-full sm:!w-[259px] !rounded-[4px]"
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <CustomSelect
        label={t("sort_by")}
        labelClassName="!mb-2"
        className="!w-full sm:!w-[208px] common-select"
        value={sortDirection}
        options={sortOptions}
        disabled={disabled}
        onChange={(value) => {
          if (isSortDirection(value)) {
            onSortDirectionChange(value);
          }
        }}
      />
    </div>
  );
};

export default TachographCardsToolbar;
